<div [formGroup]="formGroup" class="flex-container justup-dialog">
  <div class="flex-row px-24 w100 border-box">
    <vl-logo textColor="var(--color-on-background)" class="w100"/>
  </div>
  <div class="flex-row w100 justify-center py-24">
    <span class="subheading-1">{{ 'auth.login' | trans }}</span>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>email</mat-label>
    <input matInput
           autocomplete="on"
           autocapitalize="off"
           type="login"
           (keyup.enter)="onLogin()"

           formControlName="username"/>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>mot de passe</mat-label>
    <input #pwd matInput
           autocomplete="on"
           placeholder="********" type="password" formControlName="password" (keyup.enter)="onLogin()"/>
  </mat-form-field>

  <vl-divider [label]="'Ou scannez votre badge'"></vl-divider>


  <vl-big-button style="position: relative;text-align:center;margin-top: 30px" [text]="'auth.login' | trans"
                 [loading]="loading()"
                 [disabledValues]="[formGroup]"
                 (action)="onLogin()" color="primary"/>

  <div class="mt-12 flex-row align-center justify-center">
    <a class="privacy" href="https://justup.io/privacy.html">Politique de confidentialité</a>
  </div>
</div>
